<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="7"/><path d="M8.2 7.9a1.9 1.9 0 1 1 2.6 1.8c-.5.2-.8.7-.8 1.2v.4"/><path d="M10 14.1h.01"/></svg>
</template>
